// FileButton.js
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getImageForCrop } from '../../utils/upload';
import { Modal } from 'react-bootstrap';
import logo from '../../static/images/logo-countpicula-dark.png';
import { chooseImage } from '../../utils/google';

class FileButton_Class extends Component {
  state = {
    show: false
  };

  onChange = ({ target: { files } }) => {
    const { dispatch, handleShow } = this.props;
    const file = files[0];
    if (!file) {
      return;
    }
    if (!/png|jpeg|jpg|gif/gi.test(file.type)) {
      this.setState({
        show: true
      });
      return;
    }
    getImageForCrop(file, dispatch);
    handleShow();
  };

  handleClose = () => {
    this.setState({
      show: false
    });
  };

  handleClick = () => {
    const { handleShow } = this.props;
    handleShow();
    this.handleClose();
  };

  chooseImageOnClick = id => {
    chooseImage(id);
  };

  render() {
    const { classname, txt, handleShow, id } = this.props;
    const style = {
      width: '0.1px',
      height: '0.1px',
      opacity: '0',
      overflow: 'hidden',
      position: 'absolute',
      zIndex: '-1'
    };
    return (
      <React.Fragment>
        <input
          type="file"
          id="upload_image"
          name="upload_image"
          accept="image/jpeg, image/gif, image/png"
          style={style}
          onChange={this.onChange}
          onClick={
            txt === 'Choose an image' ? () => this.chooseImageOnClick(id) : null
          }
        />
        <label htmlFor="upload_image" className={classname}>
          {txt}
        </label>
        <Modal show={this.state.show} onHide={this.handleClose} bsSize="large">
          <Modal.Header closeButton>
            <div>
              <h2 className="modal-title" id="m_crop">
                <span>Vat a pic-kle!</span>
              </h2>
              <img
                className="logo-img"
                src={logo}
                width="117"
                height="75"
                alt=""
              />
            </div>
          </Modal.Header>
          <div className="modal-body">
            <p>Files must be JPG, PNG or GIF format.</p>
          </div>
          <div className="modal-footer">
            <div className="footer-buttons">
              <button
                type="button"
                className="btn btn-default btn-bevel"
                onClick={this.handleClose}
              >
                Cancel
              </button>
              <FileButton
                txt="Pic again"
                classname="btn btn-primary btn-bevel"
                handleShow={handleShow}
              />
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  id: state.uploads.template_key,
  txt: ownProps.txt,
  url: state.uploads.file_data
});
export const FileButton = connect(mapStateToProps)(FileButton_Class);



// WEBPACK FOOTER //
// ./src/comps/Feature/FileButton.js